import type { BaseResponse } from "~/@types";
import { http } from "~/libs/axios";

export type VerificationType = "nib" | "store_screenshot";

// `pending_manual` = OCR gagal 3x, dokumen masuk antrean tinjauan manual.
export type VerificationStatus = "pending" | "pending_manual" | "verified" | "rejected";

export interface VerificationDoc {
  _id: string;
  id?: string;
  type: VerificationType;
  fileUrl: string;
  status: VerificationStatus;
  documentNumber?: string | null;
  ocrAttempts?: number;
  note?: string | null; // alasan dari verifikator, tampil saat status rejected
  reviewedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface VerificationPayload {
  type: VerificationType;
  fileUrl: string;
}

type VerificationListResponse = BaseResponse & { data: VerificationDoc[] };
type VerificationDocResponse = BaseResponse & { data: VerificationDoc };

export const verification = {
  // Daftar dokumen verifikasi milik user (satu dokumen aktif per `type`).
  getMine: () => http<VerificationListResponse>("GET", { url: "/verification" }),

  // Kirim bukti dokumen. Mengirim ulang `type` yang sama akan menimpa dokumen sebelumnya.
  submit: (payload: VerificationPayload) =>
    http<VerificationDocResponse>("POST", { url: "/verification", data: payload }),
};
